import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularEditorModule } from '@kolkov/angular-editor';
// for Calendar
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { provideNgxWebstorage, withLocalStorage, withSessionStorage } from 'ngx-webstorage';
import { AppComponent } from './app.component';
import { Configuration } from './app.constants';
import { AppRoutes } from './app.routes';
import { AuthGuard } from './core/guard/auth.guard';
import { RootStoreModule } from './root-store/root-store.module';
import { NavigationModule } from './shared/components/navigation/navigation.module';
import { ApiInterceptor } from './shared/components/utilityservices/apiHttpinterceptor';
import { UtilitiesService } from './shared/components/utilityservices/utilityservice';
import { LoaderService } from './shared/directives/loader.service';
import { LogoService } from './shared/directives/logo.service';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutes,
    SharedModule,
    NgMultiSelectDropDownModule.forRoot(),
    AngularEditorModule,
    BrowserAnimationsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    NgxPanZoomModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatToolbarModule,
    MatSidenavModule,
    NavigationModule,
    CommonModule,
    RootStoreModule,
  ],
  providers: [
    AuthGuard,
    LoaderService,
    LogoService,
    UtilitiesService,
    Configuration,
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideNgxMask(),
    provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
  ],
})
export class AppModule {}
